import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { tabsClass } from './styles';
import { getUidStr } from '../utils/uid';
import { defer } from '../utils/uid';
import getDataset from '../utils/dom/getDataset';
import { getDirectionClass } from '../utils/classname';

var Tab =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Tab, _PureComponent);

  var _super = _createSuper2(Tab);

  function Tab(props) {
    var _this;

    _classCallCheck(this, Tab);

    _this = _super.call(this, props);
    _this.element = void 0;
    _this.uid = void 0;
    _this.getActiveStyle = _this.getActiveStyle.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.uid = "tab_unique_".concat(getUidStr());
    return _this;
  }

  _createClass(Tab, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      defer(function () {
        if (_this2.props.isActive) _this2.handleClick(true);
      });
    }
  }, {
    key: "getActiveStyle",
    value: function getActiveStyle() {
      var _this$props = this.props,
          shape = _this$props.shape,
          align = _this$props.align,
          background = _this$props.background,
          color = _this$props.color,
          border = _this$props.border,
          isActive = _this$props.isActive,
          isVertical = _this$props.isVertical;
      if (shape === 'line' || shape === 'dash') return {};
      var style = {
        background: background,
        color: color
      };
      if (shape === 'bordered') return {
        background: background
      };
      if (shape !== 'line' && !isVertical) style.borderColor = "".concat(border, " ").concat(border, " ").concat(isActive ? background : border, " ").concat(border);
      if (shape !== 'line' && align === 'vertical-left') style.borderColor = "".concat(border, " ").concat(isActive ? background : border, "  ").concat(border, " ").concat(border);
      if (shape !== 'line' && align === 'vertical-right') style.borderColor = "".concat(border, " ").concat(border, " ").concat(border, " ").concat(isActive ? background : border);
      return style;
    }
  }, {
    key: "handleClick",
    value: function handleClick(init) {
      var _this$props2 = this.props,
          onClick = _this$props2.onClick,
          id = _this$props2.id,
          isActive = _this$props2.isActive,
          disabled = _this$props2.disabled,
          last = _this$props2.last;
      if (disabled) return;
      if (init !== true) onClick(id, isActive);

      if (!this.element) {
        this.element = document.querySelector(".".concat(this.uid));
      }

      if (this.element && this.element.getBoundingClientRect) {
        this.props.moveToCenter(this.element.getBoundingClientRect(), last, id === 0);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          isActive = _this$props3.isActive,
          disabled = _this$props3.disabled,
          children = _this$props3.children,
          shape = _this$props3.shape,
          otherProps = _objectWithoutProperties(_this$props3, ["isActive", "disabled", "children", "shape"]);

      var style = this.getActiveStyle();
      var isBordered = shape === 'bordered';

      var props = _objectSpread2({
        className: classnames(tabsClass('tab', isActive && (isBordered ? 'tab-bordered-active' : 'active'), disabled && 'disabled', isBordered && getDirectionClass('tab-bordered')), this.uid),
        onClick: this.handleClick,
        style: style
      }, getDataset(otherProps));

      if (children.type && children.type.isTabLink) {
        return (
          /*#__PURE__*/
          React.cloneElement(children, _objectSpread2({}, props))
        );
      }

      return (
        /*#__PURE__*/
        React.createElement("div", props, children)
      );
    }
  }]);

  return Tab;
}(PureComponent);

export default Tab;